import { DataBean } from "../DataBean";

export class ShelfInventory extends DataBean {

    public async deleteShelfInventory(idShelfInventory: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteShelfInventory_Number", [idShelfInventory]);
    }

    public async getShelfInventory(idShelfInventory: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.ShelfInventory_getShelfInventory_Number", [idShelfInventory]);
    }

    public async getShelfInventoryCatalog(idStore: number, regexStr: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getShelfInventoryCatalog_Number_String_Number_Number", [idStore, regexStr, page, recordsPerPage]);
    }

    public async updateShelfInventory(bean: Record<string, any>): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.inventory.ShelfInventory_updateShelfInventory_com.quickdataerp.bean.inventory.ShelfInventory",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.inventory.ShelfInventory"
                }
            ]
        );
    }

}
